/**
 * Gets the title of a node from the engineering toolbar
 * @param {Array} toolbar - Engineering toolbar array
 * @param {string} nodeKey - Node key (e.g., 'wing', 'fuselage')
 * @returns {string|null} Node title or null if not found
 */
export const getNodeTitle = (toolbar, nodeKey) => {
  for (const section of toolbar) {
    const tool = section.tools?.find(t => t.node === nodeKey);
    if (tool) {
      return tool.title;
    }
  }
  return null;
};
